export default "__VITE_ASSET__BnsqLfgs__"